import { useEngagementTracking } from '@/hooks/useEngagementTracking';

/**
 * Component that enables engagement tracking across the app.
 * Should be placed inside BrowserRouter to have access to location.
 */
const EngagementTracker = () => {
  useEngagementTracking();
  return null;
};

export default EngagementTracker;
